// extracted by mini-css-extract-plugin
module.exports = {"taxonomyNavigator":"TaxonomyNavigator_taxonomyNavigator__eoSH7"};